<!-- <header>
  <nav class="navbar navbar-expand-sm navbar-light bg-white border-bottom box-shadow mb-3">
    <div class="container">
      <a class="navbar-brand" routerLink="/credit-report-summary">Credit Reports</a>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-between" id="navbarNav">
        <ul class="navbar-nav flex-grow-1" *ngIf="isAuthenticated">
          <li class="nav-item">
            <a class="nav-link text-dark" routerLink="/credit-report-summary">Credit Report Summary</a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-dark" routerLink="/credit-report-reasons">Credit Report Reasons</a>
          </li>
          <li class="nav-item">
            <button (click)="logout()" class="nav-link btn btn-link text-dark">Logout</button>
          </li>
        </ul>

        <ul class="navbar-nav" *ngIf="!isAuthenticated">
          <li class="nav-item">
            <button (click)="login()" class="btn btn-primary">Login</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header> -->

<header class="no-print">
  <div class="header">
    <div class="row">
      <div class="header__logo-wrapper">
        <a routerLink="/" class="link--on-dark"> <span class="icon icon--logo"></span><span class="header__title">Credit Report</span> </a>
      </div>
      <div class="header__nav-wrapper">
        <opus-global-nav></opus-global-nav>
      </div>
      <!-- <div class="header__search-wrapper">
        <opus-quick-search></opus-quick-search>
      </div> -->
      <div class="header__account-wrapper">
        <opus-account-dropdown></opus-account-dropdown>
      </div>
    </div>
  </div>
</header>
